<template>
  <div class="row gy-0 gx-10">
    <!--begin::Col-->
    <div class="col-xl-12">
      <!--begin::General Widget 1-->
      <div class="mb-10">
        <div class="">
          <div class="card-header border-0">
            <h3 class="card-title align-items-center flex-column">
              <span class="card-label page-title fw-bolder fs-3 mb-1"
                >Order a Barrel</span
              >
              <!-- <span class="text-muted mt-1 fw-bold fs-7">Active Barrels</span> -->
            </h3>
          </div>
        </div>

        <OrderBarrelFormProgress v-model="formProgress" />

        <div class="spacer-y-10"></div>

        <!--begin::Tabs-->
        <div class="card col align-center col-xl-6 my-7">
          <div class="card-body py-6">
            <div class="tab-content">
              <!--begin::Tap pane-->
              <div
                class="tab-pane fade show active"
                id="kt_table_widget_5_tab_1"
              >
                <label class="d-flex flex-stack cursor-pointer my-6">
                  <!--begin:Label-->
                  <span class="d-flex align-items-center me-2">
                    <span class="d-flex flex-column">
                      <span class="fw-bolder fs-6"
                        >Recipient Details
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          v-b-tooltip.hover
                          title="The recipient is the person who will be receiving the barrel when it is delivered in Jamaica"
                          data-bs-original-title="The recipient is the person who will be receiving the barrel when it is delivered in Jamaica"
                          aria-label="The recipient is the person who will be receiving the barrel when it is delivered in Jamaica"
                        ></i
                      ></span>
                    </span>
                    <!--end:Info-->
                  </span>

                  <!--end:Label-->
                  <!--begin:Input-->
                  <span
                    class="
                      form-check form-check-custom form-check-solid
                      is-valid
                    "
                  >
                  </span>
                  <!--end:Input-->
                </label>

                <div class="fv-row mb-10 fv-plugins-icon-container">
                  <!--begin::Label-->
                  <div class="row">
                    <div class="col-6">
                      <label
                        class="d-flex align-items-center fs-5 fw-bold mb-2"
                      >
                        <span class="required">First Name</span>
                      </label>
                      <!--end::Label-->
                      <!--begin::Input-->
                      <input
                        type="text"
                        class="form-control form-control-lg form-control-solid"
                        v-model="consignee.firstName"
                        placeholder=""
                      />
                    </div>
                    <div class="col-6">
                      <label
                        class="d-flex align-items-center fs-5 fw-bold mb-2"
                      >
                        <span class="required">Last Name</span>
                      </label>
                      <!--end::Label-->
                      <!--begin::Input-->
                      <input
                        type="text"
                        class="form-control form-control-lg form-control-solid"
                        v-model="consignee.lastName"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <label
                        class="d-flex align-items-center fs-5 fw-bold mb-2"
                      >
                        <span class="required">TRN</span>
                        <i
                          class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip"
                          v-b-tooltip.hover
                          title="Recipient's taxpayer number necessary for clearance"
                          aria-label="TRN"
                        ></i>
                      </label>
                      <!--end::Label-->
                      <!--begin::Input-->
                      <i
                        data-bs-toggle="tooltip"
                        v-b-tooltip.hover
                        title="Enter Digits Only"
                      >
                        <input
                          type="text"
                          class="
                            form-control form-control-lg form-control-solid
                          "
                          v-model="trnInput"
                          @keypress="filterGivenTrn($event, trnInput)"
                          @focus="trnOnFocus = true"
                          @blur="trnOnFocus = false"
                          placeholder=""
                        />
                      </i>
                    </div>
                    <div class="col-6">
                      <label
                        class="d-flex align-items-center fs-5 fw-bold mb-2"
                      >
                        <span class="required">Telephone</span>
                      </label>
                      <!--end::Label-->
                      <!--begin::Input-->
                      <i
                        data-bs-toggle="tooltip"
                        v-b-tooltip.hover
                        title="Enter Digits Only"
                      >
                        <input
                          type="text"
                          class="
                            form-control form-control-lg form-control-solid
                          "
                          v-model="phoneNumberInput"
                          @focus="phoneNumberOnFocus = true"
                          @blur="phoneNumberOnFocus = false"
                          @keypress="
                            filterGivenPhoneNumber($event, phoneNumberInput)
                          "
                          placeholder=""
                          inputmode="numeric"
                        />
                      </i>
                    </div>
                  </div>
                  <label class="d-flex align-items-center fs-5 fw-bold mb-2">
                    <span class="required">Email</span>
                  </label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input
                    type="text"
                    class="form-control form-control-lg form-control-solid"
                    v-model="consignee.email"
                    placeholder=""
                  />

                  <label class="d-flex align-items-center fs-5 fw-bold mb-2">
                    <span class="required">Address Line 1</span>
                  </label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input
                    type="text"
                    class="form-control form-control-lg form-control-solid"
                    v-model="consignee.address.line1"
                    placeholder=""
                  />
                  <label class="d-flex align-items-center fs-5 fw-bold mb-2">
                    <span>Address Line 2</span>
                  </label>
                  <!--end::Label-->
                  <!--begin::Input-->
                  <input
                    type="text"
                    class="form-control form-control-lg form-control-solid"
                    v-model="consignee.address.line2"
                    placeholder=""
                  />
                  <div class="row">
                    <div class="col-6">
                      <label
                        class="d-flex align-items-center fs-5 fw-bold mb-2"
                      >
                        <span class="required">Town</span>
                      </label>
                      <!--end::Label-->
                      <!--begin::Input-->
                      <input
                        type="text"
                        class="form-control form-control-lg form-control-solid"
                        v-model="consignee.address.town"
                        placeholder=""
                      />
                    </div>
                    <div class="col-6">
                      <label
                        class="d-flex align-items-center fs-5 fw-bold mb-2"
                      >
                        <span class="required">Parish</span>
                      </label>
                      <!--end::Label-->
                      <!--begin::Input-->
                      <select
                        class="form-control form-control-lg form-control-solid"
                        v-model="consignee.address.parish"
                      >
                        <option
                          v-for="location in parishes"
                          :key="location"
                          :value="location"
                        >
                          {{ location }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <!--end::Input-->
                  <div
                    class="fv-plugins-message-container invalid-feedback"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="card plain-card col align-center col-xl-4 my-7">
            <button
              class="btn btn-primary fw-bold px-6 py-5 w-100 mb-4 mt-6"
              data-bs-toggle="modal"
              data-bs-target="#kt_modal_create_app"
              @click="$emit('previous')"
            >
              <svg
                width="22"
                height="23"
                viewBox="0 0 22 23"
                fill="none"
                style="transform: scale(-1, 1)"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.9775 21.5121C16.4009 21.5121 20.7975 17.1156 20.7975 11.6921C20.7975 6.26869 16.4009 1.87213 10.9775 1.87213C5.55403 1.87213 1.15747 6.26869 1.15747 11.6921C1.15747 17.1156 5.55403 21.5121 10.9775 21.5121Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M10.9775 15.6201L14.9055 11.6921L10.9775 7.7641"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M7.04956 11.6921H14.9056"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
              Previous
            </button>
          </div>
          <div
            v-if="finalScreen"
            class="card plain-card col align-center col-xl-4 my-7"
          >
            <button
              :class="nextBtnClass"
              data-bs-toggle="modal"
              data-bs-target="#kt_modal_create_app"
              @click="$emit('pay')"
            >
              Place Order
              <span
                v-if="loading"
                class="spinner-border spinner-border-md align-middle ms-2"
              ></span>
              <svg
                v-if="!loading"
                width="22"
                height="23"
                viewBox="0 0 22 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.9775 21.5121C16.4009 21.5121 20.7975 17.1156 20.7975 11.6921C20.7975 6.26869 16.4009 1.87213 10.9775 1.87213C5.55403 1.87213 1.15747 6.26869 1.15747 11.6921C1.15747 17.1156 5.55403 21.5121 10.9775 21.5121Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M10.9775 15.6201L14.9055 11.6921L10.9775 7.7641"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M7.04956 11.6921H14.9056"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
          </div>
          <div v-else class="card plain-card col align-center col-xl-4 my-7">
            <button
              :class="nextBtnClass"
              data-bs-toggle="modal"
              data-bs-target="#kt_modal_create_app"
              @click="$emit('next')"
            >
              Next
              <svg
                width="22"
                height="23"
                viewBox="0 0 22 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.9775 21.5121C16.4009 21.5121 20.7975 17.1156 20.7975 11.6921C20.7975 6.26869 16.4009 1.87213 10.9775 1.87213C5.55403 1.87213 1.15747 6.26869 1.15747 11.6921C1.15747 17.1156 5.55403 21.5121 10.9775 21.5121Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M10.9775 15.6201L14.9055 11.6921L10.9775 7.7641"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M7.04956 11.6921H14.9056"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
      <!-- mb-10 -->
      <!--end::General Widget 1-->
    </div>
    <!--end::Col-->
    <!--begin::Col-->

    <!--end::Col-->
  </div>
</template>

<script>
import mixins from "vue-typed-mixins";
import parishes from "@/config/parish.json";
import FieldValidationMixin from "@/mixins/FieldValidationMixins";
import OrderBarrelFormProgress from "@/components/OrderBarrelFormProgress.vue";

export default mixins(FieldValidationMixin).extend({
  name: "OrderBarrelConsignee",
  components: {
    OrderBarrelFormProgress,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    finalScreen: {
      type: Boolean,
      default: false,
    },
    formProgress: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      parishes: parishes,
      trnOnFocus: false,
      phoneNumberOnFocus: false,
    };
  },
  computed: {
    consignee: {
      get() {
        return this.value;
      },
    },
    trnInput: {
      get() {
        try {
          if (!this.trnOnFocus) {
            return this.consignee.trn;
          }
          return this._countDigits(this.consignee.trn).digits;
        } catch (e) {
          error(e);
        }
        return "";
      },
      set(value) {
        this.consignee.trn = this.trnFormatting(value);
      },
    },
    phoneNumberInput: {
      get() {
        try {
          if (!this.phoneNumberOnFocus) {
            return this.consignee.contactNumber;
          }
          return this._countDigits(this.consignee.contactNumber).digits;
        } catch (e) {
          error(e);
        }
        return "";
      },
      set(value) {
        this.consignee.contactNumber = this.phoneNumberFormatting(value);
      },
    },
    nextBtnClass() {
      const defaultClass = "btn fw-bold px-6 py-5 w-100 mb-4 mt-6";

      if (
        !this.consignee.firstName ||
        !this.consignee.lastName ||
        !this.consignee.trn ||
        !this.consignee.contactNumber ||
        !this.consignee.email ||
        !this.consignee.address.line1 ||
        !this.consignee.address.town ||
        !this.consignee.address.parish ||
        !this.trnMatchPattern(this.consignee.trn) ||
        !this.phoneNumberMatchPattern(this.consignee.contactNumber)
      )
        return `${defaultClass} btn-secondary disabled`;
      return `${defaultClass} btn-primary`;
    },
  },
  watch: {
    consignee: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true,
    },
  },
  methods: {
    setTrn() {
      this.formatTrn();
      this.consignee.trn = this.formattedTrn;
    },
    setPhoneNumber() {
      this.formatPhoneNumber();
      this.consignee.contactNumber = this.formattedPhoneNumber;
    },
  },
});
</script>

<style></style>
